import React from 'react';
import Layout from '../components/layout/Layout';

function AppInfoPage() {
  return (
    <Layout>
      <section className="section-about-banner">
        <div className="section-about-banner__container">
          <div className="section-about-banner__img">
            <div className="section-about-banner__text">
              <span className="section_about_header_name section-about-banner__main-headin">SunPanda</span>
              <h2 className="main-headin">О МОБИЛЬНОМ ПРИЛОЖЕНИИ</h2>
            </div>
          </div>
        </div>
      </section>

      <section className="section-about-application">
        <div className="section-about-application__container">
          <div className="container">
            <h2 className="second-heading text-center mb-4">Скачайте приложение SunPanda</h2>
            <p className="text-center mb-5"></p>

            <div className="row justify-content-center">
              <div className="col-xs-12 col-sm-10 col-md-8">
                <div className="text-center">
                  <p></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-about-benefits">
        <h2 className="section-about-benefits__second-heading">ПРЕИМУЩЕСТВА ПРИЛОЖЕНИЯ</h2>
        <div className="container row bi-align-center">
          <div className="section-about-benefits__item col-xs-12 col-sm-6 col-md-4">
            <h3 className="section-about-benefits__item-heading">Быстрый заказ</h3>
            <p className="section-about-benefits__item-text"></p>
          </div>
          <div className="section-about-benefits__item col-xs-12 col-sm-6 col-md-4">
            <h3 className="section-about-benefits__item-heading">Push-уведомления</h3>
            <p className="section-about-benefits__item-text"></p>
          </div>
          <div className="section-about-benefits__item col-xs-12 col-sm-6 col-md-4">
            <h3 className="section-about-benefits__item-heading">Удобство</h3>
            <p className="section-about-benefits__item-text"></p>
          </div>
        </div>
      </section>
    </Layout>
  );
}

export default AppInfoPage;
